import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-ms-responsible',
  templateUrl: './ms-responsible.component.html',
  styleUrls: ['./ms-responsible.component.scss','../../../../mystery-shopper/mystery-shopper.component.scss' ]

})
export class MsResponsibleComponent {

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router
  ) { }

}
